import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import {
    formatTime,
    getIdFromProps,
    timeStringToDate,
    timeToDatetime
} from "../../utils/utils";
import TablePanel from "../../components/TablePanel";
const {sinkEvent} = commons;
import ZmenitPoradiModal from "../../components/ZmenitPoradiModal";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
import * as ciselnikActions from "../../actions/ciselnikActions";
import {toastr} from "react-redux-toastr";
import DopravaTerminForm from "../../forms/DopravaTerminForm";
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Stránka administrace - termíny konkrétního způsobu dopravy
 */
class DopravaTerminyPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchZpusobDopravyIfNeeded(getIdFromProps(this.props)));
        this.props.dispatch(ciselnikActions.fetchTerminyDopravyIfNeeded(getIdFromProps(this.props)));
    };

    handleCreateTermin = () => {
        const {zpusobDopravyDetail, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            DopravaTerminForm,
            {
                onSubmit: (data) => {
                    const vo = {...data,
                        zpusobDoprava: zpusobDopravyDetail.data,
                        casDoruceniOd: data.casDoruceniOd ? timeStringToDate(data.casDoruceniOd) : null,
                        casDoruceniDo: data.casDoruceniDo ? timeStringToDate(data.casDoruceniDo) : null,
                        rozhodnyPocetMinut: data.rozhodnyPocetMinut ? data.rozhodnyPocetMinut : null,
                        neaktivni: data.neaktivni ? data.neaktivni : false,
                    };
                    return CiselnikApi.createTerminDoprava(zpusobDopravyDetail.data.id, vo);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateTerminyDopravy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('new_delivery_time'),
            {size: "sm"}
        ));
    };

    handleEditTermin = (termin) => {
        const {zpusobDopravyDetail, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            DopravaTerminForm,
            {
                onSubmit: (data) => {
                    const vo = {...data,
                        zpusobDoprava: zpusobDopravyDetail.data,
                        casDoruceniOd: data.casDoruceniOd ? timeToDatetime(data.casDoruceniOd) : null,
                        casDoruceniDo: data.casDoruceniDo ? timeToDatetime(data.casDoruceniDo) : null,
                        rozhodnyPocetMinut: data.rozhodnyPocetMinut ? data.rozhodnyPocetMinut : null,
                        neaktivni: data.neaktivni ? data.neaktivni : false,
                    };
                    return CiselnikApi.updateTerminDoprava(vo, zpusobDopravyDetail.data.id, termin.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateTerminyDopravy());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: {
                    ...termin,
                    casDoruceniOd: formatTime(termin.casDoruceniOd, null, "HH:mm:ss"),
                    casDoruceniDo: formatTime(termin.casDoruceniDo, null, "HH:mm:ss"),
                },
            },
            t('change_delivery_time'),
            {size: "sm"}
        ));
    };

    handleDeleteTermin = (termin) => {
        const {zpusobDopravyDetail, t} = this.props;
        this.props.dispatch(
            modal.ModalActions.showConfirm(
                t('delete_delivery_time'),
                <span>Termín dopravy <b>{termin.nazevTermin}</b> bude odstraněn.</span>,
                () => {
                    CiselnikApi.deleteTerminDoprava(zpusobDopravyDetail.data.id, termin.id).then(() => {
                        this.props.dispatch(ciselnikActions.invalidateTerminyDopravy());
                    });
                },
                null,
                t('delete')
            )
        );
    };

    handleZmenitPoradi = () => {
        const {zpusobDopravyDetail, terminyList, dispatch, t} = this.props;
        if (terminyList.rows.length !== 0) {
            this.props.dispatch(modal.ModalActions.show(
                ZmenitPoradiModal,
                {
                    onOrderChanged: (changedIdsMap) => {
                        CiselnikApi.updatePoradiTerminDoprava(zpusobDopravyDetail.data.id, changedIdsMap).then(() => {
                            dispatch(modal.ModalActions.hide());
                            dispatch(ciselnikActions.invalidateTerminyDopravy());
                        });
                    },
                    items: terminyList.rows,
                    renderItem: i => {
                        return <CardBody key={i.item.id}>
                            <Row>
                                <Col xs={12}>{i.item.nazevTermin}</Col>
                            </Row>
                        </CardBody>;
                    },
                },
                t('change_in_order'),
                {size: "lg", className: "card-form-modal"}
            ));
        } else {
            toastr.warning("Žádné termíny dopravy k řazení");
        }
    };

    handleVcetneNeaktivnich = (e) => {
        const {terminyList} = this.props;
        this.props.dispatch(ciselnikActions.filterTerminyDopravy({
            ...terminyList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (termin) => <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="1" onClick={sinkEvent(this.handleEditTermin.bind(this, termin))}>Upravit</DropdownItem>
            <DropdownItem key="2" onClick={sinkEvent(this.handleDeleteTermin.bind(this, termin))}>Smazat</DropdownItem>
        </FixedDropDownButton>;

    render() {
        const {zpusobDopravyDetail, terminyList, t} = this.props;

        if (!zpusobDopravyDetail.fetched || !terminyList.fetched) {
            return <Loader/>;
        }

        let content;
        if (terminyList.rows.length !== 0) {
            content = terminyList.rows.map((termin) => {
                return <CardBody key={termin.id} className={termin.neaktivni ? "neaktivni" : ""}>
                    <ActionsRow actions={this.renderContextMenu(termin)} onClick={this.handleEditTermin.bind(this, termin)}>
                        <Row>
                            <Col xs={4}>{termin.nazevTermin}</Col>
                            <Col xs={2}>{termin.casDoruceniOd ? formatTime(termin.casDoruceniOd) : "-"}</Col>
                            <Col xs={2}>{termin.casDoruceniDo? formatTime(termin.casDoruceniDo) : "-"}</Col>
                            <Col xs={2}>{termin.rozhodnyPocetMinut ? termin.rozhodnyPocetMinut : "-"}</Col>
                            <Col xs={2}>{termin.neaktivni ? t('no') : t('yes')}</Col>
                        </Row>
                    </ActionsRow>
                </CardBody>;
            });
        } else {
            content = <CardBody><i>{t('no_delivery_time')}</i></CardBody>
        }

        const zpusobDopravy = zpusobDopravyDetail.data;
        const vcetneNeaktivnich = terminyList.filter.vcetneNeaktivnich || false;

        return <AdminPage
                title={t('state_delivery_time',{deliveryTime: zpusobDopravy.nazevDoprava})}
                subtitle={t('delivery_to_delivery_time',{deliveryName: zpusobDopravy.nazevDoprava})}
                content={
                    <div>
                        <ButtonToolbar>
                            <Button color="primary" onClick={this.handleCreateTermin}>{t('new_m')}</Button>
                            <Button color="secondary" onClick={this.handleZmenitPoradi}>{t('change_order')}</Button>
                            <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                        </ButtonToolbar>
                        <TablePanel header={
                            <Row>
                                <Col xs={4}>{t('labels.name')}</Col>
                                <Col xs={2}>{t('labels.delivery_time_from')}</Col>
                                <Col xs={2}>{t('labels.deliver_date_to')}</Col>
                                <Col xs={2}>{t('labels.decisive_minutes')}</Col>
                                <Col xs={2}>{t('active')}</Col>
                            </Row>
                        }>
                            {content}
                        </TablePanel>
                    </div>
                }
            />
    }
}

function mapStateToProps(state) {
    return {
        zpusobDopravyDetail: utils.storeFromArea(state, ciselnikActions.ZPUSOB_DOPRAVY_AREA),
        terminyList: utils.storeFromArea(state, ciselnikActions.TERMINY_DOPRAVY_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(DopravaTerminyPage));
